import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "emojiDialog" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "sendButtonContainer" }

import vue from '../../../../adapter-vue';
import { IEmojiGroupList } from '../../../../interface';
import {
  TUIStore,
  StoreName,
  IConversationModel,
  TUITranslateService,
} from '../../../../@aidesk/uikit-engine';
import {
  EMOJI_GROUP_LIST,
  BASIC_EMOJI_URL_MAPPING,
  convertKeyToEmojiName,
  BASIC_EMOJI_URL,
  filterEmojisInNonChineseEnv,
} from '../../emoji-config';


export default /*@__PURE__*/_defineComponent({
  __name: 'emoji-dialog-mobile',
  emits: ['insertEmoji', 'onClose', 'sendMessage'],
  setup(__props, { emit: __emit }) {

const { ref, onMounted, onUnmounted } = vue;
const emits = __emit;
const list = ref<IEmojiGroupList>(initEmojiList());
const currentConversation = ref();
const emojiPickerListRef = ref();
const currentEmojiList = ref<string[]>(list?.value[0]?.list);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  currentEmojiList.value = filterEmojisInNonChineseEnv(list.value[0].list);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const select = (item: any, index: number) => {
  const options: any = {
    emoji: { key: item, name: convertKeyToEmojiName(item) },
    type: 'basic',
    url : BASIC_EMOJI_URL + BASIC_EMOJI_URL_MAPPING[item],
  };
  emits('insertEmoji', options);
};

function sendMessage(){
    emits('sendMessage');
}

function onCurrentConversationUpdate(conversation: IConversationModel) {
  currentConversation.value = conversation;
}

function initEmojiList() {
  return EMOJI_GROUP_LIST;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", {
      ref_key: "emojiPickerListRef",
      ref: emojiPickerListRef,
      class: "emojiDialogList"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentEmojiList), (childrenItem, childrenIndex) => {
        return (_openBlock(), _createElementBlock("li", {
          key: childrenIndex,
          class: "emojiDialogList-item",
          onClick: ($event: any) => (select(childrenItem, childrenIndex))
        }, [
          _createElementVNode("img", {
            class: "emoji",
            src: _unref(BASIC_EMOJI_URL) + _unref(BASIC_EMOJI_URL_MAPPING)[childrenItem]
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      }), 128))
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "sendButton",
        onClick: sendMessage
      }, _toDisplayString(_unref(TUITranslateService).t("发送")), 1)
    ])
  ]))
}
}

})